import React from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import ReportPageAction from "../page-action/ReportPageAction";
import IndustrySectorTable from "../../../components/table/all-tables/reportable/industrysectors/IndustrySectorTable";
import { IndustryReport } from "../../../locales/en";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";

export default function IndustrySector() {
  return (
    <>
      <TablePagesTitle mainTitle={IndustryReport?.mainTitle} />

      <ReportPageAction subheading={IndustryReport?.mainTitle} />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0 ">
          <div className="col-md-12">
            <IndustrySectorTable />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
